<template>
  <jet-form-section @submitted="save()">
    <template #title>
      Billing Receipt Email
    </template>

    <template #description>
      <p>If you want to receive receipts other than your current email, please update this field.</p>
      <br>
      <p>If you are already on a subscription, please contact support@agilesuite.io after you update the field. </p>
    </template>

    <template #form>
      <!-- Email -->
      <div class="col-span-6 sm:col-span-4">
        <jet-label for="email" value="Billing Receipt Email"/>
        <jet-input id="email" type="email" class="mt-1 block w-full"
                   v-model="this.billing.receipt_email"/>
      </div>
    </template>

    <template #actions>
      <jet-button :class="{ 'opacity-25': this.submitting }" :disabled="this.submitting">
        Save
      </jet-button>
    </template>
  </jet-form-section>
</template>

<script>
import JetButton from '@/Jetstream/Button'
import JetFormSection from '@/Jetstream/FormSection'
import JetInput from '@/Jetstream/Input'
import JetInputError from '@/Jetstream/InputError'
import JetLabel from '@/Jetstream/Label'
import JetActionMessage from '@/Jetstream/ActionMessage'
import JetSecondaryButton from '@/Jetstream/SecondaryButton'
import {message} from "ant-design-vue";

export default {
  components: {
    JetActionMessage,
    JetButton,
    JetFormSection,
    JetInput,
    JetInputError,
    JetLabel,
    JetSecondaryButton,
  },

  props: ['billing'],
  data() {
    return {
      submitting: false,
      photoPreview: null,
    }
  },

  methods: {
    save() {
      this.submitting = true;
      axios
          .post(route("billing.receipt.update"), {
            receipt_email: this.billing.receipt_email
          })
          .then((response) => {
            this.submitting = false;
            message.success('Successfully updated', 5);
          })
          .catch((error) => {
            this.submitting = false;
            console.log(error);
            message.error('Our system cannot update it, please contact us.', 5);
          });
    }
  },
}
</script>
